export async function getAppsCatalogForDevice(params, managerApiRepository) {
    const { firmwareVersion, targetId, provider } = params;
    return managerApiRepository.catalogForDevice({
        firmwareVersion,
        provider,
        targetId,
    });
}
//# sourceMappingURL=getAppsCatalogForDevice.js.map